import "./Legislation.css";

import { Breadcrumb, message, Table, type TableColumnsType } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  SectionHeader,
  TableMenuDropdown,
  UploadLegislationCsvModal,
} from "../../_lib/_components";
import {
  deleteLegislation,
  getLegislations,
  type LegislationType,
  useAppSelector,
} from "../../_lib/_store";

export const LegislationPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, legislations } = useAppSelector(
    (state) => state.legislation,
  );
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getLegislations(messageApi);
  };

  const columns: TableColumnsType<LegislationType> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Url",
      dataIndex: "url",
      key: "url",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Site name",
      dataIndex: "siteName",
      key: "siteName",
    },
    {
      title: "Metadata",
      dataIndex: "metadata",
      key: "metadata",
      render: (_, obj) => <p>{obj?.metadata?.originalMetadata}</p>,
    },
    {
      title: "Package Id",
      dataIndex: "package",
      key: "package",
      render: (_, obj) => <p>{obj?.package?.name}</p>,
    },
    {
      title: "Category Id",
      dataIndex: "category",
      key: "category",
      render: (_, obj) => <p>{obj?.category?.name}</p>,
    },
    {
      title: "Sub Category Id",
      dataIndex: "subCategoryId",
      key: "subCategoryId",
      render: (_, obj) => <p>{obj?.subCategory?.name}</p>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: LegislationType) => {
    switch (key) {
      case "show":
        navigate(`/legislation-link/show`, { state: { legislation: obj } });
        break;
      case "edit":
        navigate(`/legislation-link/edit`, { state: { legislation: obj } });
        break;
      case "delete":
        deleteLegislation(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="policy">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "Legislation Link",
              },
            ]}
          />
          <UploadLegislationCsvModal />
        </div>
        <SectionHeader
          dataLength={legislations?.length}
          createRoute="legislation-link"
        />
        <Table
          sticky
          dataSource={legislations}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1300 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
